import { render, staticRenderFns } from "./DashBoardView.vue?vue&type=template&id=7450fc0e&"
import script from "./DashBoardView.vue?vue&type=script&lang=js&"
export * from "./DashBoardView.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports